<script setup lang="ts">
import Step1 from './components/step-1.vue'
import Step2 from './components/step-2.vue'
import { useEscolhaPlanoStore } from './store/useEscolhaPlanoStore'

const props = defineProps<{
  suplierId?: string
}>()

definePage({
  meta: {
    layout: 'blank',
    action: 'read',
    subject: 'auth',
  },
})

const store = useEscolhaPlanoStore()
const route = useRoute()

const {
  fetchFornecedor,
} = store

const {
  step,
  empty,
} = storeToRefs(store)

onMounted(() => {
  fetchFornecedor(route.params.id ?? props.suplierId)
})
</script>

<template>
  <VContainer
    v-if="empty"
    class="fill-height"
    fluid
  >
    <VRow
      align="center"
      justify="center"
    >
      <VCol
        cols="12"
        sm="8"
        md="6"
      >
        <VCard
          class="text-center pa-6"
          elevation="2"
        >
          <VIcon
            size="64"
            color="error"
            class="mb-4"
          >
            mdi-alert-circle
          </VIcon>
          <h2 class="mb-2 text-h4 font-weight-bold">
            Fornecedor não encontrado
          </h2>
          <p class="mb-6 text-body-1">
            Desculpe, não conseguimos encontrar o fornecedor que você está procurando.
          </p>
          <VBtn
            color="primary"
            @click="$router.push('/admin/fornecedor')"
          >
            Voltar para lista de fornecedores
          </VBtn>
        </VCard>
      </VCol>
    </VRow>
  </VContainer>
  <template v-else>
    <Step1 v-if="step === 1" />
    <Step2 v-else-if="step === 2" />
  </template>
</template>
